import React from 'react';
import { connect } from 'react-redux';
import { AUDIT_LOG_SHOW } from 'src/constants/EndpointUrls';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';
import { useTranslation } from 'react-i18next';
import { getList } from 'src/reducers/common/listReducer';
import { REDUCER_NAME } from 'src/reducers/clients/auditLogs';
import { formatDateWithHour } from 'src/utils/Date';

const AuditLogsTable = ({ auditLogs }) => {
  const { t } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list m-table-fixed">
        <thead>
          <tr>
            <th width={137}>{t('features.AuditLogs.AuditLogsTable.acted_user_name')}</th>
            <th width={137}>{t('features.AuditLogs.AuditLogShow.operation_target')}</th>
            <th width={137}>{t('features.AuditLogs.AuditLogsTable.action_type')}</th>
            <th width={130}>{t('features.AuditLogs.AuditLogShow.operation_type')}</th>
            <th width={137}>{t('features.AuditLogs.AuditLogsTable.operation_detail')}</th>
            <th width={180}>{t('features.AuditLogs.AuditLogShow.date')}</th>
          </tr>
        </thead>
        <tbody>
          {(!auditLogs || auditLogs.length === 0) && (
            <tr>
              <td colSpan={6}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
          {auditLogs.map(log => (
            <tr
            className={'table-hover'}
            key={log.id}
            onClick={() => redirectTo(concatParamsToUrl(AUDIT_LOG_SHOW, { id: log.id }))}
            >
              <td>{log.actedUserName}</td>
              <td>{log.operationTargetName}</td>
              <td>{log.actionType}</td>
              <td>{log.operationLabel}</td>
              <td>{log.resourceSubLabel}</td>
              <td>{formatDateWithHour(log.createdAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  auditLogs: getList(REDUCER_NAME, state)
});

export default connect(mapStateToProps)(AuditLogsTable);
